type WorkspaceUserRole = "OWNER" | "ADMIN" | "READER" | "WRITER" | "CONTRIBUTOR" | "SILENTREADER" | "CUSTOM";

export type WorkspaceUser = {
  id: string;
  workspaceId: string;
  role: WorkspaceUserRole;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
  user: User;
};

export type WorkspaceUserWithPossibleMissingValues = Omit<WorkspaceUser, "user"> & {
  user: UserWithMissingValues;
}

export type CreateWorkspaceUserPayload = {
  email: string;
  role: string;
};

export type User = {
  id: string;
  name: string;
  picture?: string;
  email: string;
};

export type UserWithMissingValues = {
  id: string;
  name?: string;
  picture?: string;
  email?: string;
};

export type UpdateWorkspaceUserPayload = {
  role: string;
};

export const fillInMissingUserInWorkspaceUser = (user: WorkspaceUserWithPossibleMissingValues): WorkspaceUser => {
  return {
    ...user,
    user: {
      id: user.user.id,
      name: user.user.name || user.user.email || user.user.id,
      email: user.user.email || user.user.id,
      picture: user.user.picture || "",
    }
  }
};

export const fillInMissingUserInWorkspaceUsers = (users: WorkspaceUserWithPossibleMissingValues[]): WorkspaceUser[] => {
  return users.map(user => fillInMissingUserInWorkspaceUser(user))
}